import { Text, View } from '@react-pdf/renderer'
import moment from 'moment'
import { IInvoiceFr } from '../../../types/invoice-fr'
import { styles } from '../styles'
import { useTranslation } from 'react-i18next'

const Header = ({ invoiceData }: { invoiceData: IInvoiceFr }) => {
  const { t } = useTranslation()

  return (
    <View style={styles.headerContainer}>
      <Text style={styles.title}>{t('sharedDiagnostic.invoice.title')}</Text>
      <Text style={styles.subTitle}>
        {t('shared.common.shortNumber')} {invoiceData.invoiceNumber}
      </Text>
      <Text style={{ ...styles.grayText, fontStyle: 'italic', marginTop: 5 }}>
        {t('shared.common.createdAt')}{' '}
        {moment(invoiceData.createdAt).format('DD/MM/YYYY')}
      </Text>
    </View>
  )
}

export default Header
